export default "__VITE_PUBLIC_ASSET__f28c9664__"